<template>
  <div>
    <div class="card">
      <div>
        <div class="count">x<span :style="{fontSize: '24px'}">{{item.ItemCount}}</span></div>
        <div class="main" v-html="item.ItemName.replaceAll('\n', '<br>')"></div>
        <div class="main">${{item.ItemPrice}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    price () {
      return parseInt(this.item.price || 0) + this.item.items.map(e => parseInt(e.priceDiff || 0) + parseInt(e.add.map(a => a.price).reduce((a, b) => a + b, 0) || 0)).reduce((a, b) => a + b, 0)
    }
  }

}
</script>

<style lang="scss" scoped>
.count {
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #FF7373;
  text-align: start;
}
.opt {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #8C8C8C;
  display: flex;
  flex-wrap: wrap;
  gap: .5em;
}
.main {
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #787878;
}
.sub {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  color: var(--color-pri);
}
.card {
  display: flex;
  flex-direction: column;
  gap: 5px;
  &>div{
    display: grid;
    grid-template-columns: 60px 1fr 90px;
    &>:nth-child(2) {
      text-align: start;
    }
    &>:nth-child(3) {
      text-align: end;
    }
  }
  &>div.optrow{
    display: grid;
    grid-template-columns: 60px 1fr;
    &>:nth-child(2) {
      text-align: start;
    }
    &>:nth-child(3) {
      text-align: end;
    }
  }
}
</style>
